import axiosClient from "../axiosClient";
import { cachedRequest } from "../../utils/apiCache";
export function getAllShorts(data, options = {}) {
  let bearerTokenHeader = sessionStorage.getItem("accessToken"); //get token from the session storage
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${bearerTokenHeader}`; //"Whenever you make a request using axiosClient, send this token with it."

  let path = window.location.pathname;
  const request = () =>
    path === "/" || path === "/home"
      ? axiosClient.post("/home/shorts/all", JSON.stringify(data))
      : axiosClient.post("/shorts/all", JSON.stringify(data));

  if (options.useCache === false) return request();

  if (path === "/" || path === "/home") {
    return cachedRequest(`shorts:home:${JSON.stringify(data || {})}`, request, {
      force: options.force === true,
    });
  }
  return cachedRequest(`shorts:all:${JSON.stringify(data || {})}`, request, {
    force: options.force === true,
  });
}

//for single short
export function getSingleShort(id) {
  let bearerTokenHeader = sessionStorage.getItem("accessToken");
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${bearerTokenHeader}`;
  return axiosClient.get(`/shorts/view/${id}`);
}

export function likeCurrentShort(data) {
  let bearerTokenHeader = sessionStorage.getItem("accessToken");
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${bearerTokenHeader}`;
  return axiosClient.post(`/short/like`, JSON.stringify(data));
}
